import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const RoundedCheckmarkIcon: React.FC<Props> = ({
  color,
  ...svgProps
}) => {
  return (
    <SVG
      viewBox="0 0 13 13"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 13)}
      strokeWidth="2"
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2.6 6.7264 5.6574 9.75l5.3926-6.5" />
    </SVG>
  );
};
